import Dashboard from "./Dashboard";

const DashboardWrapper = ({ userDetail, todayAppointments }) => (
  <Dashboard
    userDetail={userDetail}
    todayAppointments={todayAppointments}
  />
);

export default DashboardWrapper;
